import { ADMISSION_TYPE_GUEST_LIST } from '@domain/admission';

import { type AdmissionFlow, type AdmissionFormType, type SectionKey } from './admission-form.type';
import {
  ADMISSION_FORM_FLOW_ADMISSION,
  ADMISSION_FORM_FLOW_PRESET,
  ADMISSION_FORM_TYPE_PASS,
  SECTION_ORDER,
} from './constants';

export interface SectionVisibilityContext {
  flow: AdmissionFlow;
  type: AdmissionFormType;
  isClubCountryItaly: boolean;
  hasItalyRegulationContext: boolean;
  isSuperAdmin: boolean;
  canExcludeSiaeOffers: boolean;
  isEventScoped: boolean;
  isEditMode: boolean;
}

export const getVisibleSections = ({
  flow,
  type,
  isClubCountryItaly,
  hasItalyRegulationContext,
  isSuperAdmin,
  canExcludeSiaeOffers,
  isEventScoped,
  isEditMode,
}: SectionVisibilityContext): SectionKey[] => {
  const isPass = type === ADMISSION_FORM_TYPE_PASS;
  const isAdmissionFlow = flow === ADMISSION_FORM_FLOW_ADMISSION;
  const isPreset = flow === ADMISSION_FORM_FLOW_PRESET;

  const visible: Record<SectionKey, boolean> = {
    basicInfo: true,
    distribution: isAdmissionFlow || isPass || isPreset,
    addOns: !isPass && type !== ADMISSION_TYPE_GUEST_LIST && isAdmissionFlow,
    advanced: true,
    formFields: true,
    appearance: true,
    vatRate: !isClubCountryItaly,
    regulation:
      ((isEventScoped && !isPass) || (isPass && !isEventScoped && isEditMode)) &&
      hasItalyRegulationContext &&
      (isSuperAdmin || canExcludeSiaeOffers),
  };

  return SECTION_ORDER.filter((key) => visible[key]);
};
